import { FarmerPage } from '@features/dashboard/farmerDashboard/farmerProfile/farmerProfilePage';

export const Farmer = () => {
	return <FarmerPage />;
};
